import { entity, equals, query, string, truthy } from '~/prix'

export default function AgentInformationQuery(agentHash?: string) {
  return query('legalEntityAttendanceAttendant')
    .select({
      hash: entity('legalEntityAttendanceAttendant').property('hash'),
      agentCpf: entity('legalEntityAttendanceAttendant').property('cpf'),
      name: entity('legalEntityAttendanceAttendant').property('coalesce'),
      endDate: entity('legalEntityAttendanceAttendant').property('endDate'),
    })
    .where(
      ...[
        agentHash !== undefined
          ? equals(
              entity('legalEntityAttendanceAttendant').property('hash'),
              string().value(agentHash),
            )
          : null,
      ].filter(truthy),
    )
    .limit(1)
}
